export var FEATURE_FLAGS_V5 = /*#__PURE__*/function (FEATURE_FLAGS_V5) {
  FEATURE_FLAGS_V5["MODULE_HANA_AI"] = "MODULE_HANA_AI";
  FEATURE_FLAGS_V5["TALENT_SIDE_MENU_NAVIGATION_V2"] = "TALENT_SIDE_MENU_NAVIGATION_V2";
  FEATURE_FLAGS_V5["LEARNING_FOUNDATION_LIDER"] = "LEARNING_FOUNDATION_LIDER";
  FEATURE_FLAGS_V5["SIDEBAR_V2"] = "SIDEBAR_V2";
  return FEATURE_FLAGS_V5;
}({});
export var FEATURE_FLAGS_V5_KEYS = /*#__PURE__*/Object.values(FEATURE_FLAGS_V5);